// TODO: should be moved to separate file (module import style)
// TODO: can use a more modern mobile menu
window.addEventListener('DOMContentLoaded', initMenu, false);
window.addEventListener('DOMContentLoaded', initSubMenu, false);

function initMenu(){

	const menuElement = document.getElementById('menu');

	if (!menuElement) {
		return;
	}

	document.getElementById('menu').addEventListener('click', menuOnClick, false);

	let hoofdMenuElement = document.getElementById('hoofdnavigatie');

	let aElements = hoofdMenuElement.getElementsByTagName('a');
	for (let i=0;i<aElements.length;i++){
		if (aElements[i].getAttribute('href').match(/^\/?#/)){
			aElements[i].addEventListener('click', menuOnClick, false);
		}
	}

}

function initSubMenu(){

	const menuItemsWithSubMenu = document.querySelectorAll('.menu-item-has-children');
	if (!menuItemsWithSubMenu) {
		return;
	}

	menuItemsWithSubMenu.forEach(menuItem => {
		menuItem.addEventListener('click', () => {

			toggleSubMenu(menuItem);

		});
	});

}

function menuOnClick(e){
	const clickedElement = e.target;
	const headerWrapper = document.getElementById('wrapper_header');

	if (clickedElement.parentElement.classList.contains('menu-item-has-children') && clickedElement.tagName === 'A') {
		return;
	}
	else if (clickedElement.tagName === 'BUTTON' || clickedElement.tagName === 'A'){
		headerWrapper.classList.toggle('active');
		document.body.classList.toggle('nav-active');
		closeSubMenus();
	}

}

function toggleSubMenu(menuItem){
	menuItem.classList.toggle('open-submenu');
}

function closeSubMenus() {
	const activeSubmenuItems = document.querySelectorAll('.menu-item-has-children.open-submenu');
	if (!activeSubmenuItems) {
		return;
	}

	activeSubmenuItems.forEach(activeItem => {

		activeItem.classList.remove('open-submenu');

	});
}

//Check if menu clips outside of window, add class left if it does.
window.addEventListener('DOMContentLoaded', () => {
	let timeout;
	window.onresize = function() {
		clearTimeout(timeout);
		timeout = setTimeout(resized, 500);
	};

	if (window.innerWidth >= 1320){
		const subMenus = document.querySelectorAll('.sub-menu');
		if (!subMenus){
			return;
		}

		subMenus.forEach(subMenu => {
			let subMenuBounds = subMenu.getBoundingClientRect();

			if (subMenuBounds.right > (window.innerWidth || document.documentElement.clientWidth)) {
				subMenu.classList.add('left');
			}
		});
	}
});

function resized() {
	if (window.innerWidth >= 1320){
		document.body.classList.remove('nav-active');
		const subMenus = document.querySelectorAll('.sub-menu');

		if (!subMenus){
			return;
		}

		subMenus.forEach(subMenu => {
			if (subMenu.classList.contains('changed')){
				return;
			}
			let subMenuBounds = subMenu.getBoundingClientRect();

			if (subMenuBounds.right > (window.innerWidth || document.documentElement.clientWidth)) {
				subMenu.classList.add('left');
			}
		});
	}
}